export default "__VITE_ASSET__Ny1CIQEn__"